import React from 'react'
import { Col, Row } from 'reactstrap'
import { BiSolidRightArrow } from 'react-icons/bi'
import {  Facebook, GeoAltFill, Instagram, TelephoneFill, Tiktok, Youtube } from 'react-bootstrap-icons'
import { MdEmail } from 'react-icons/md'

const AppointmentLandingFooter = () => {
  return (
    <div id='website-responsive'>
            <Row className='pt-md-5 pt-4 pb-4 pb-md-4 px-md-5 px-4'>
            <Col md='5' className=''>
            <div className='pb-2 pt-'>
                <img src='logo/United-Lab-Care-Logo-1536x281.png' alt='' height='auto' width='280px' className='' /> 
            </div>  

            <div className='py-3'>
                <div className='fs-ss-17-1 fw-600 text-ss-black'>
                    Toxicology Testing, General Blood Work, RSV / Influenza / Respiratory Pathogen Panel and
                    COVID-19 Testing Solutions for Individuals, Businesses and Institutions.
                </div>
            </div>
            <div className=''>
                <div className='fs-ss-12 fw-400 text-ss-black'>
                    *Same day results depend on the type of the test.
                </div>
            </div>
                </Col>

                    <Col md='2' className=''>
                        <div className=''>
                            <div className=''>
                                <div className='fs-ss-20 text-montserrat fw-700 text-ss-black mb-3' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    Quick Links
                                </div>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> About
                                </div>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> Panel Testing
                                </div>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <BiSolidRightArrow className='fs-ss-12'/> Covid Testing
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md='4' className=''>
                        <div className=''>
                            <div className=''>
                                <div className='fs-ss-20 text-montserrat fw-700 text-ss-black mb-3' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    Get in Touch
                                </div>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <TelephoneFill className='fs-ss-18 me-2'/> (800) 442-1663
                                </div>
                                <div className='fs-ss-15 text-montserrat fw-500 text-hover-blue text-ss-black mb-2' style={{ letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <MdEmail className='fs-ss-18 me-2'/> info@unitedlabcare.com
                                </div>
                                <div className='fs-ss-15 text-montserrat text-hover-blue fw-500 text-ss-black mb-2 flex-centr' style={{ display:'flex', letterSpacing:'0.5px', cursor:'pointer'}}>
                                    <GeoAltFill className='fs-ss-18 me-2'/> 246 E Janata Blvd # 115, Lombard, 60148
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col className='me-md-5 flex-center11' style={{ marginTop:'rem', }}>
                        <div className='pb-3 px-md-0 px-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.facebook.com/unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Facebook className='fs-ss-24-2 text-ss-primary'/>
                            </a>
                        </div>
                        <div className='pb-3 px-md-0 px-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.instagram.com/unitedlabcare/' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Instagram className='fs-ss-24-2 text-ss-black'/>
                            </a>
                        </div>
                        <div className='pb-3 px-md-0 px-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.youtube.com/@unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Youtube className='fs-ss-24-2' style={{ color:'#cd201f'}}/>
                        </a>
                        </div>
                        <div className='pb-3 px-md-0 px-3 flex-center10' style={{ cursor:'pointer'}}>
                        <a href='https://www.tiktok.com/@unitedlabcare' target='_blank' className='' style={{ textDecoration:'none'}}>
                            <Tiktok className='fs-ss-24-2' style={{ color:'#69727d'
                           }}/>
                        </a>
                        </div>

                        
                    </Col>
                </Row>
            </div>  
  )
}

export default AppointmentLandingFooter